import React, {ComponentType} from "react";
import UpsellMenuOptions from "./index";
import {IProps, IContainerProps, IServices, IHandlers, IBaseProps} from './types';
import MenuOptionActionService from "app/actions/menuOption.actions";
/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import useForceUpdate from "use-force-update";
import AppThemeService from "app/services/theme/appTheme.service";
import {IWidgetTheme, IBookingMenuOption} from "shared-types/index";
import MenuOptionReducerService from "app/fakeReducer/menuOption.reducer";
import BookingService from "external-services/booking-service";
import {IntlProvider} from "react-intl/dist";
import {LocaleService} from "app/services/locale/locale.service";

const NS = 'UpsellMenuOptionsContainer';

const propsKeys: string[] = keys<IProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const handlersKeys: string[] = keys<IHandlers>();
const servicesKeys: string[] = keys<IServices>();

const themeVal: IWidgetTheme = AppThemeService.getAppThemeAsWidgetTheme();

const ThemeWrap = function(all: IContainerProps & IServices) {

  const forceUpdate = useForceUpdate();

  /**
    * Sorts 'all' into IServices, IProps and IContainerProps
    */
  const {
  }: IServices = ReactUtilsService.getObjectByKeys(all, servicesKeys) as IServices
  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;

  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  const {paymentDetails, maxCovers, currency, updateBookingOption}: IContainerProps = containerProps;

  const state = MenuOptionReducerService.getState();


  const upsellOptions = paymentDetails && paymentDetails.optionsUpsell ? paymentDetails.optionsUpsell : [];

  const bookingSelectedOptions = state.booking.selectedMenuOptions;

  const options = upsellOptions // if upsell present - send upsell options instead of normal BO

  const singleMenuPerBooking =  false;

  /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);

  props.theme = themeVal;

  const covers: number = maxCovers ? maxCovers : 0;
  props.selectedMenuOptions = BookingService.getBookingOptions(
    options, bookingSelectedOptions, covers, singleMenuPerBooking, true
  );
  props.menuOptionsImplicit = upsellOptions;
  props.currency = currency || 'AUD';



  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
    handleUpsellUpdate: async (selectedMenuOptions: IBookingMenuOption[]) => {
      await MenuOptionActionService.updateSelectedMenuOption(selectedMenuOptions, true);
      const newState = MenuOptionReducerService.getState();
      updateBookingOption(newState.booking, true);
      forceUpdate();
    }
  }

  return ReactUtilsService.containerWrap(
    <IntlProvider locale={LocaleService.getLocale()}>
      <UpsellMenuOptions {...props} {...handlers} />
    </IntlProvider>
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2AUpsellMenuOptions: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
